// noinspection JSAnnotator
/**
 * Draws a grid of dotted line across the canvas of a scene.
 */
export default class Grid extends Phaser.GameObjects.Graphics {
  constructor(scene: Phaser.Scene, gridColor: number, gridDistanceBetweenLines: number, depth: number, options?: Phaser.Types.GameObjects.Graphics.Options) {
    super(scene, options);

    // 0) Configuration

    const gridThickness = 1
    const gridAlpha = 0.3
    const strokeLength = 2
    const gapLength = 2
    const gridOffsetX = 1; // info: little offset to left. I don't know why exactly this is needed, but it looks smoother

    // 1) Create graphic to render a grid


    this.lineStyle(gridThickness, gridColor, gridAlpha);

    // 2) Render all horizontal lines into "gridGraphics"

    let y = 0;
    while (y <= scene.sys.canvas.height) {
      let x = 0;
      while (x <= scene.sys.canvas.width) {
        const line = new Phaser.Geom.Line(x, y, x + strokeLength, y);
        x += strokeLength + gapLength
        this.strokeLineShape(line)
      }
      y += gridDistanceBetweenLines
    }

    // 3) Render all vertical lines

    let x = 0 + gridOffsetX;
    while (x <= scene.sys.canvas.width) {
      let y = 0;
      while (y <= scene.sys.canvas.height) {
        const line = new Phaser.Geom.Line(x, y, x + strokeLength, y);
        y += strokeLength + gapLength
        this.strokeLineShape(line)
      }
      x += gridDistanceBetweenLines
    }

    this.setDepth(depth)
  }
}
